import { axiosGet, axiosPost } from "../axios/config";

export const enableTwoFA = async () => {
	const response = await axiosPost(`/api/2fa/enable`);
	return response;
};

export const disableTwoFA = async () => {
	const response = await axiosPost(`/api/2fa/disable`);
	return response;
};

export const sendTwoFA = async (data) => {
	const response = await axiosPost(`/api/2fa`, data);
	return response;
};

export const getUserGoogleSecretKey = async (data) => {
	const response = await axiosGet("/api/retrieve-key", data);
	return response;
};

export const sendTwoFAPhoneNumber = async (data) => {
	const response = await axiosPost("/api/2faPhoneNumber", data);
	return response;
};

export const sendTwoFASms = async (data) => {
	const response = await axiosPost("/api/2faSMS", data);
	return response;
};

export const reset2FAOption = async () => {
	return await axiosGet("/api/reset2FAOption");
};
